import { SVGProps, Ref, forwardRef } from 'react';

export const LabelThumbFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 .667C2.5.667.667 4.333.667 8S2.5 15.333 8 15.333 15.333 11.667 15.333 8 13.5.667 8 .667m.197 2.751a.87.87 0 0 0-1.238.714c-.055.675-.302 1.259-.732 1.88v5.986h3.546c1.468-.007 2.029-.503 2.235-1.97l.276-1.97c.2-1.413-.185-1.925-1.526-1.966H8.985V4.91c0-.64-.203-1.213-.788-1.492m-4.53 5.166c0-1.49.47-2.04 1.851-2.096v5.505c-1.382-.056-1.851-.606-1.851-2.096z"
                fill="currentColor"
            />
        </g>
    </svg>
));
LabelThumbFilledSize16Glyph.displayName = 'LabelThumbFilledSize16Glyph';
